import { MatomoEvents } from './matomo.const';
import { useMatomo } from './matomo.service';

export const useAgentActionsMattomoMiddleware = () => {
  const matomo = useMatomo();

  const agentActionsMattomoMiddleware = (
    config: {
      action: typeof MatomoEvents['Agent Menu Bulk Action'][number] | typeof MatomoEvents['Agent Menu Single Action'][number];
      value?: number;
      name?: string;
      bulk?: boolean;
    },
    callback?: () => any,
  ) => {
    matomo?.trackEvent({
      category: config.bulk ? 'Agent Menu Bulk Action' : 'Agent Menu Single Action',
      action: config.action,
      value: config.value,
      name: config.name,
    });
    if (callback) callback();
  };

  return { agentActionsMattomoMiddleware };
};
